__turbopack_context__.v({
  "container": "_79AeNG_container",
  "content": "_79AeNG_content",
  "icon": "_79AeNG_icon",
  "iconExpanded": "_79AeNG_iconExpanded",
  "inner": "_79AeNG_inner",
  "trigger": "_79AeNG_trigger",
});
